<app-svg-icon class="animate-pulse" [iconSize]="200" iconName="nexus-yms" />
